
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

import { logout } from "@artegeie/mona-sdk/auth";

import useTranslation from 'Hooks/useTranslation';

import Loader from 'Components/Layout/Loader';

import 'scss/components/content/account.scss';

export default function AccountLogout() {

	const navigate = useNavigate();

	const { t } = useTranslation();

	const { blogUrl } = window.appConfig;

	// loader
	const { loader } = window.appConfig;
	const [loading, setLoading] = useState(true);
	setTimeout(
		() => setLoading(false),
		loader.timeout
	);

	useEffect(() => {
		logout()
		.then(
			function (response) {
				setLoading(false);
				window.location.href = blogUrl
			}
		)
		.catch(
			function (response) {
				setLoading(false);
				console.debug( 'not logged in');
				navigate( '/account-login', { trigger: true } );
			}
		);
	}, []);

	return (

		<div id='account-page'>

			{ loading && <Loader /> }
			<div>
				{ t('account.logout.loggingOut') }
			</div>

		</div>
	);
};

